import { flexCenter, media } from '@anm/styles/helpers';
import styled from 'styled-components';

const CalendarSyncLinksModalWrapperAdaptiveStyles = media.tablet`
    max-width: 100%;
`;

const CalendarSyncLinksModalWrapper = styled.div`
  max-width: 500px;
  padding: 30px 30px 35px;
  pointer-events: all;
  text-align: center;
  p {
    margin: 0;
    line-height: 1.75;
  }
  ${CalendarSyncLinksModalWrapperAdaptiveStyles};
`;

const CalendarSyncLinksWrapperAdaptiveStyles = media.tablet`
    flex-direction: column;
    align-items: center;
    a {
        margin-bottom: 20px;
    }
`;

export const CalendarSyncLinksWrapper = styled.div`
  ${flexCenter};
  flex-wrap: wrap;
  margin: 22px 0;
  justify-content: space-between;
  a {
    width: 130px;
    height: 130px;
    border: solid 1px #cbdce5;
    border-radius: 5px;
    ${flexCenter};
    flex-direction: column;
    &:hover {
      background-color: rgba(34, 148, 223, 0.1);
    }
    img {
      max-width: 50px;
      margin-bottom: 14px;
    }
    span {
      font-size: 18px;
      font-weight: bold;
      line-height: 1.11;
      color: #292a2b;
    }
  }
  ${CalendarSyncLinksWrapperAdaptiveStyles};
`;

export default CalendarSyncLinksModalWrapper;
